import type Layout from '@/modules/layouts/classes/Layout'
import { AssetType } from '@/types/assets'
import { KisweSelectOption } from 'kiswe-ui'
import { Feature, hasFeature } from '@/featureFlags/featureFlags'
import { BoxStylingSimpleCg } from '../classes/BoxStylingSimpleCg'
import { CAST_PROPERTY_BOX_NAMES } from '../types'

export const BOX_MIN_WIDTH = 10
export const BOX_MAX_WIDTH = 1920

export const BOX_MIN_HEIGHT = 10
export const BOX_MAX_HEIGHT = 1080

export const isBoxStylingSimpleCg = (obj: unknown): obj is BoxStylingSimpleCg => obj instanceof BoxStylingSimpleCg

export const hasCastPropertyBoxes = (layout: Layout): boolean => {
  return Object.values(layout.boxes).some((box) => box.isTaggedBox)
}

export const getBoxTypeOptions = (hasUsedAllTags: boolean = false): KisweSelectOption<AssetType>[] => {
  const options: KisweSelectOption<AssetType>[] = [
    { label: 'Video', value: AssetType.Video },
    { label: 'Image', value: AssetType.Graphic }
  ]
  if (hasFeature(Feature.FanRoom)) {
    options.push({ label: 'Special Field', value: AssetType.SimpleCG, disabled: hasUsedAllTags })
  }
  return options
}

export const getBoxTagOptions = (existingTags: string[] = []): KisweSelectOption<string>[] => {
  return CAST_PROPERTY_BOX_NAMES.map((name: string) => ({
    label: name,
    value: name,
    disabled: existingTags.includes(name)
  }))
}
